import {
  VPC_LOADED,
  VPC_ERROR,
  VPC_CLEAR,
  VPC_SET_SAVE_STATE,
  VPC_DIRTY_CONFIGURATION,
  VPC_SET_SAVE_CODE,
  VPC_SET_SAVE_PROGRESS_STATUS,
} from '../actionConstants';
import { Action, RootAction } from '../../generalTypes';
import { VpcLoadedAction, VpcSaveProgressStatusEnumType } from './vpcTypes';
import { ConfirmationSummaryShareDesignStateEnum } from '@inter-ikea-kompis/component-configuration-summary';

export const actionVpcLoaded = (
  code: string,
  currentView: string
): Action<VpcLoadedAction> => ({
  type: VPC_LOADED,
  payload: {
    currentView: currentView,
    code: code,
  },
});

export const actionVpcError = (): RootAction => ({
  type: VPC_ERROR,
});

export const actionVpcClear = (): RootAction => ({
  type: VPC_CLEAR,
});

export const actionSetSaveVpcState = (
  state: ConfirmationSummaryShareDesignStateEnum
) => ({
  type: VPC_SET_SAVE_STATE,
  payload: { state },
});

export const actionSetSavedVpcCode = (vpcCode: string) => ({
  type: VPC_SET_SAVE_CODE,
  payload: { vpcCode },
});

export const actionSetDirtyConfiguration = (dirtyConfiguration: boolean) => ({
  type: VPC_DIRTY_CONFIGURATION,
  payload: { dirtyConfiguration },
});

export const actionSetVpcSaveProgressStatus = (
  progressStatus: VpcSaveProgressStatusEnumType
) => ({
  type: VPC_SET_SAVE_PROGRESS_STATUS,
  payload: { progressStatus },
});
